import { colors, radius } from "../theme";

export default function EnterpriseStatusPill({
  label,
  tone = "neutral",
}) {
  const tones = {
    neutral: {
      bg: colors.slate100,
      color: colors.slate700,
      border: colors.slate200,
    },
    info: {
      bg: "#e0f2fe",
      color: "#0369a1",
      border: "#bae6fd",
    },
    warning: {
      bg: "#fef3c7",
      color: "#92400e",
      border: "#fde68a",
    },
    danger: {
      bg: "#fee2e2",
      color: "#991b1b",
      border: "#fecaca",
    },
    success: {
      bg: "#dcfce7",
      color: "#166534",
      border: "#bbf7d0",
    },
    purple: {
      bg: "#ede9fe",
      color: "#6d28d9",
      border: "#ddd6fe",
    },
  };

  const t = tones[tone] || tones.neutral;

  return (
    <span
      style={{
        display: "inline-block",
        padding: "4px 10px",
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 900,
        background: t.bg,
        color: t.color,
        border: `1px solid ${t.border}`,
        textTransform: "uppercase",
      }}
    >
      {label}
    </span>
  );
}